/**
 * Leanplum interface — snapshot-backed no-op shim.
 *
 * Leanplum is shutting down. This module's previous implementation hit
 * api.leanplum.com via the vendored SDK; the runtime calls are now no-ops
 * that serve cached values from `window.gMarket.recommendedPrice` and
 * `window.gMarket.recommendedPriceCoop` (populated server-side by
 * `server/config.js` from `server/data/leanplum-snapshot.json`).
 *
 * The public API (`setup`, `getVars`, `setTrafficSource`) is unchanged so
 * call sites in main.js, blocket-routes.js, etc. don't need to know. Replace
 * this module's body when migrating to CleverTap.
 */

window.tiptapp = window.tiptapp || {};

tiptapp.leanplum = (function init() {
  function setup(cb) {
    if (typeof cb === 'function') {
      // Fire on next tick to preserve the async-ish timing the LP SDK had,
      // so call sites that assume their code runs after the current frame
      // (e.g. main.js's initial recommended-price render) still behave the
      // same.
      setTimeout(cb, 0);
    }
  }

  function getVars(name) {
    if (!window.gMarket) return undefined;
    if (name === `recommendedPrice${window.gMarket.countryCode}`) return window.gMarket.recommendedPrice;
    if (name === 'recommendedPriceCoop') return window.gMarket.recommendedPriceCoop;
    return undefined;
  }

  function setTrafficSource(/* userId, ad, referrerName */) {
    // Partner attribution was previously written to LP via
    // `Leanplum.setUserAttributes`. LP discards writes today and is going
    // away. The CleverTap migration will replace this with a real call.
    /*
    // Typical pattern
    switch (referrerName) {
      case 'blocket':
        source = {
          adId: String(ad._id),
          reference: ad.referrer.reference,
          publisherId: 'TTB1',
          publisherName: 'Blocket',
          publisherSubPublisher: ad.from.area || ad.from.country || ad.country,
          publisherSubSite: 'Blocket + Tiptapp',
          publisherSubCampaign: referrerName,
          publisherSubAdGroup: '',
          publisherSubAd: ad.title
        };
        break;

      case 'budi':
        source = {
          adId: String(ad._id),
          reference: ad.referrer.reference,
          publisherId: 'TTBUDI1',
          publisherName: 'Budi',
          publisherSubPublisher: ad.from.area || ad.from.country || ad.country,
          publisherSubSite: 'Budi + Tiptapp',
          publisherSubCampaign: referrerName,
          publisherSubAdGroup: '',
          publisherSubAd: ad.title,
        };
        break;
    */
  }

  return { setup, getVars, setTrafficSource };
})();
